import React from 'react'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Branding from '../../components/navigation/branding'
import HttpsIcon from '@material-ui/icons/Https'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import { makeStyles } from '@material-ui/core'
import userManager from '../../utils/userManager'
import Button from 'components/Buttons'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  iconLock: {
    fontSize: '10rem',
    fill: '#b7b7b7',
  },
  btnLogin: {
    textTransform: 'none',
    padding: `${theme.spacing(2)} ${theme.spacing(9)}`,
    fontSize: '0.9rem',
  },
  paper: {
    margin: '5px',
    minHeight: '315px',
    height: '75%',
    padding: theme.spacing(6),
  },
}))

const LockScreen: React.FC = () => {
  const classes = useStyles()
  const login = (event) => {
    event.preventDefault()
    userManager.signinRedirect()
  }

  return (
    <Grid container alignItems="center" justify="center" style={{ height: '100%' }}>
      <Paper variant="outlined" className={classes.paper}>
        <Grid container alignItems="center" justify="center" direction="column" style={{ height: '100%' }}>
          <Grid item container xs alignItems="center" justify="center">
            <Branding width={300}></Branding>
          </Grid>
          <Grid item container xs alignItems="center" justify="center">
            <HttpsIcon fontSize="large" classes={{ fontSizeLarge: classes.iconLock }} />
          </Grid>
          <Grid item container xs alignItems="center" justify="center">
            <Button.Button
              variant="contained"
              color="primary"
              click={login}
              className={classes.btnLogin}
              label={<FormattedMessage id="proceed-to-login" defaultMessage="Proceed to Login" />}
              disableOnClick
              disableElevation
              icon={<LockOpenIcon style={{ fontSize: '20px' }} />}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default LockScreen
